import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth/auth.service';
import { format, parseISO, isValid } from 'date-fns';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: false
})
export class DashboardComponent {
  tier_index: number = 0;
  currentTierCount: any
  subscriptionplansPlan: any[] = [];
  subscription_plan_features: any[] = [];
  UUID: any
  pricePerListen: any
  loading: boolean = true;
  loadingListenersCount: boolean = true;
  constructor(public userService: UserService, private authService: AuthService,) { }
  displayedColumns: string[] = ['listners_count'];
  showDashboarddefaultMethod: any[] = [];
  check_subscription_plan: any;
  checkSubscriptionPlanStatus?: number;
  pricingData: any[] = [];
  hightlighted_row: number | null = null;
  user_current_subscription_plan : any 
  subscriptionEndDate:any
  subscriptionStartDate:any
  total_listeners: number = 0;
  status:boolean = false;
  will_cancel_at_end_of_period : number = 0

  ngOnInit(): void {
    this.getSubscriptionPlans()
    this.authService.token.subscribe((token: any) => {
      this.UUID = token.UUID;
    });
    // this.getTotalListenersCount();
  }


  getFormattedDate(dateString: string): string {

    // Convert "2026-07-29 14:17:06 +00:00" => "2026-07-29T14:17:06"
    let normalized = dateString.split(' ')[0] + 'T' + dateString.split(' ')[1];

    let date = parseISO(normalized);
    // console.log('Parsed date:', date);

    if (!isValid(date)) {
      // Fallback to native Date
      date = new Date(normalized);
      if (isNaN(date.getTime())) return 'Invalid date';
    }

    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    const month = format(date, 'MMMM');
    const year = date.getFullYear();

    return `${month} ${day}${suffix}, ${year}`;
  }

  getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
  
  getPlanName(planValue: number): string {
    switch (planValue) {
      case 0: return 'Hobbyist ($69.99 / year)';
      case 1: return 'Professional ($99.99 / year)';
      case 2: return 'Test Based Hobbyist ($39.99 /day)';
      default: return 'No Subscription Plan';
    }
  }


  getSubscriptionPlans() {
    this.userService.getSubscriptionDashboard().subscribe((result) => {
    let data = result[0];
    this.status = data.status;
    this.total_listeners = data.total_listeners || 0;
    const subscriptionPlanArray = data.subcription_status;
    if (subscriptionPlanArray && subscriptionPlanArray.length > 0) {
        const currentPlan = subscriptionPlanArray[0];
        this.user_current_subscription_plan = currentPlan.current_subscription_plan;
        this.subscriptionStartDate = currentPlan.subscription_start_date;
        this.subscriptionEndDate = currentPlan.subscription_end_date;
        this.will_cancel_at_end_of_period = currentPlan.will_cancel_at_end_of_period
        this.loading = false;
    } 
      if (this.status == false) {
        console.log(11);
        
        this.loading = false;
      }
    });
  }

}
